import { BaseColorType, ThemeColorKeys, ThemeColors } from '@evrekadev/evreka-ui-components'
import React from 'react'
import Chart from 'react-apexcharts'
import { PartToWholeWidgetProps } from '../PartToWholeWidget/PartToWholeWidget'
import { useRandomNumbers } from './LineGraph'

const EMPTY_VALUES = [1]

export const PieGraph: React.FC<{
  loading?: boolean
  data?: PartToWholeWidgetProps['data']
  size?: number
}> = ({ data, size = 140, loading = false }) => {
  const numbers = useRandomNumbers(loading, 3)
  const values = data?.map((d) => d.value)
  const hasItems = data && data.length > 0
  return (
    <Chart
      height={size}
      width={size}
      series={loading ? numbers : hasItems ? values : EMPTY_VALUES}
      type="donut"
      options={{
        chart: {
          selection: {
            enabled: false,
          },
          height: '100%',
          width: '100%',
          type: 'donut',
        },
        labels: data ? data.map((d) => d.label || d.key) : [],
        legend: {
          show: false,
        },
        colors: (loading || !hasItems ? DEFAULT_COLORS_DIMMED : getPieColors(data)).map(
          (c) => ThemeColors[c],
        ),
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          enabled: !loading && hasItems,
        },
        plotOptions: {
          pie: {
            donut: {
              size: '48px',
            },
            expandOnClick: false,
            dataLabels: {
              // minAngleToShowLabel: 20,
            },
          },
        },
      }}
    />
  )
}

export const getPieColors = (data?: PartToWholeWidgetProps['data']) => {
  if (!data) return DEFAULT_COLORS
  const colors = data.map((d) => d.color)
  if (colors.length === 0) {
    return DEFAULT_COLORS
  }
  return colors.map((c, i) => {
    if (c) {
      return getColorFromBaseColor(c)
    } else {
      const length = DEFAULT_COLORS.length
      const colorIndex = i % length
      return DEFAULT_COLORS[colorIndex]
    }
  })
}

const getColorFromBaseColor = (color: BaseColorType): ThemeColorKeys => {
  switch (color) {
    case 'white':
      return 'grey300'
    case 'black':
      return 'black'
    case 'transparent':
      return 'grey500'
    default:
      return `${color}500`
  }
}

export const DEFAULT_COLORS: Array<ThemeColorKeys> = [
  'green500',
  'blue500',
  'orange500',
  'yellow500',
  'purple500',
  'teal500',
  'red500',
]

export const DEFAULT_COLORS_DIMMED: Array<ThemeColorKeys> = ['grey300', 'grey200', 'grey700']
